import React, { useState, useEffect } from 'react'
import IconButton from '@mui/material/IconButton'
import Grid from '@mui/material/Grid'
import MessageIcon from '@mui/icons-material/Message'
import BugReportIcon from '@mui/icons-material/BugReport'
import Details from '../../assets/images/info.png'
import Map from '../../assets/images/map.png'
import { Dialog, DialogContent } from '@material-ui/core'
import DialogActions from '@mui/material/DialogActions'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ClearIcon from '@mui/icons-material/Clear'
import { NavigateBefore, NavigateNext } from '@mui/icons-material'
import { useNavigate, useLocation } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress'
import LoadingTime from '../../assets/images/sand_clock.png'
import usePlantTechicalViewStyles from './styles.js'
import PlantDetailsContent from './components/PlantDetailsDialog/PlantDetailsContent'
import {
  DeletenewplantNew,
  FetchPlantByID,
  fetchPlantOpData,
} from '../../services/api'
import dayjs from 'dayjs'
import moment from 'moment'
import InverterViewGraph from './components/InverterViewGraph/InverterViewGraph'
import TechnicalViewGraph from './components/TechnicalViewGraph/TechnicalViewGraph'
import EnergyAnalysisGraph from './components/EnergyAnalysisGraph/EnergyAnalysisGraph'
import { Button, Tab, Tabs } from '@mui/material'
import axios from 'axios'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import RawDataDownload from './components/RawData/RawDataDownload.jsx'
import LiveDataView from './components/LiveDataView/LiveDataView'
import { fetchIssues } from '../IssueManagement/services/issueService'

const PlantTechnicalView = () => {
  const classes = usePlantTechicalViewStyles()
  const navigate = useNavigate()
  const { state } = useLocation()
  const [hourGlassValue, setHourGlassValue] = useState(0)
  const [plantContent, setPlantContent] = useState([])
  const [notifications, setNotifications] = useState([])
  const [notificationCount, setNotificationCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [showNotifications, setShowNotifications] = useState(false)
  const [selectedNotification, setSelectedNotification] = useState(null)
  
  // Updated state variables for live data
  const [liveData, setLiveData] = useState({
    dailyEnergyMFM: 0,           // Daily Energy (MFM) - from totalEToday
    inverterEToday: 0,           // Inverter E. Today - from dailyEnergy  
    gtiValue: 0,                 // IR (Irradiation) - from gti
    specificYield: 0,            // Specific Yield - calculated PR
    co2Avoided: 0,               // CO2 Avoided - from Co2_avoided
  })
  
  const [open, setOpen] = useState(false)
  const [dleted, setdelete] = useState(false)
  const [activeTab, setActiveTab] = useState('unread')
  const [issueCount, setIssueCount] = useState(0)
  const [plantIssues, setPlantIssues] = useState([])
  const [liveTabActive, setLiveTabActive] = useState('graphs') // 'graphs' or 'live'
  const location = useLocation()
  const { totalEToday, dailyEnergy } = location.state
  const userType = localStorage.getItem('userType')

  // Main data fetching function using your new API
  const fetchLivePlantData = async () => {
    try {
      const plantId = state?.data?.id || state?.data?.id
      const currentDate = state?.selectedDate
      const token = state?.token

      console.log('Fetching live data for plant:', plantId, 'date:', currentDate)

      // Use your existing working API endpoint with plantId filter
      const response = await fetchPlantOpData(
        dayjs(currentDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        token,
        '1', // Order
        plantId
      )

      if (response?.data?.data?.[0]) {
        const plantData = response.data.data[0]
        console.log('Live plant data received:', plantData)

        // Update plant content
        setPlantContent(plantData)

        // Update live data state with the new structure
        setLiveData({
          dailyEnergyMFM: plantData?.totalEToday != null 
            ? parseFloat(plantData.totalEToday).toFixed(2) 
            : '0.00',
          inverterEToday: plantData?.dailyEnergy != null 
            ? parseFloat(plantData.dailyEnergy).toFixed(2) 
            : '0.00',
          gtiValue: plantData?.gti != null 
            ? parseFloat(plantData.gti).toFixed(2) 
            : '0.00',
          specificYield: plantData?.yield != null 
            ? parseFloat(plantData.yield).toFixed(2) 
            : '0.00',
          co2Avoided: plantData?.Co2_avoided != null 
            ? parseFloat(plantData.Co2_avoided).toFixed(2) 
            : '0.00',
        })

        console.log('Live data updated:', {
          dailyEnergyMFM: plantData?.totalEToday,
          inverterEToday: plantData?.dailyEnergy,
          gtiValue: plantData?.gti,
          specificYield: plantData?.yield,
          co2Avoided: plantData?.Co2_avoided,
        })
      }
    } catch (error) {
      console.error('Error fetching live plant data:', error)
    }
  }

  // Initial data load
  useEffect(() => {
    if (state?.data?.id || state?.data?.id) {
      // Set initial data from props
      setPlantContent(state?.data)
      
      // Initialize live data from existing state data
      setLiveData({
        dailyEnergyMFM: state?.data?.totalEToday != null 
          ? parseFloat(state.data.totalEToday).toFixed(2) 
          : '0.00',
        inverterEToday: state?.data?.dailyEnergy != null 
          ? parseFloat(state.data.dailyEnergy).toFixed(2) 
          : '0.00',
        gtiValue: state?.data?.gti != null 
          ? parseFloat(state.data.gti).toFixed(2) 
          : '0.00',
        specificYield: state?.data?.yield != null 
          ? parseFloat(state.data.yield).toFixed(2) 
          : '0.00',
        co2Avoided: state?.data?.Co2_avoided != null 
          ? parseFloat(state.data.Co2_avoided).toFixed(2) 
          : '0.00',
      })

      // Fetch fresh data immediately
      fetchLivePlantData()
      handleRemainingDate()
    }
  }, [state?.data])

  // Live data updates every 5 minutes (300000ms)
  useEffect(() => {
    if (state?.data?.id || state?.data?.id) {
      // Set up interval for live data updates every 5 minutes
      const dataUpdateInterval = setInterval(() => {
        console.log('Updating live data - 5 minute interval')
        fetchLivePlantData()
      }, 300000) // 5 minutes = 300,000 milliseconds

      // Cleanup interval on component unmount
      return () => {
        clearInterval(dataUpdateInterval)
      }
    }
  }, [state?.data?.id, state?.data?.id, state?.selectedDate, state?.token])

  // Calculate Performance Ratio using live data
  const calculatePerformanceRatio = () => {
    const yieldValue = parseFloat(liveData.specificYield || 0)
    const irradiationRaw = parseFloat(liveData.gtiValue || 0)

    // Handle invalid, zero, or extremely small values
    const irradiation = !irradiationRaw || irradiationRaw < 0.001 ? null : irradiationRaw

    if (!irradiation) {
      console.warn('Irradiation too small or missing — PR cannot be calculated.')
      return '0.00'
    }

    const ratio = yieldValue / irradiation
    return ratio.toFixed(2)
  }

  // Existing notification and other functions remain the same...
  const fetchNotifications = async () => {
    try {
      setLoading(true)
      const PlantID = state?.data?.id
      const response = await axios.get(
        `https://staging-backend-v3-express.de.energy/api/notifications/${PlantID}?page=${page}&limit=10&status=${activeTab}`
      )

      if (response.data) {
        setNotifications(response.data.notifications)
        setTotalPages(response.data.totalPages)
        if (activeTab === 'unread') {
          setNotificationCount(response.data.totalNotifications)
        }
      }
    } catch (error) {
      console.error('Error fetching notifications:', error)
      setNotifications([])
      setNotificationCount(0)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchNotifications()
    const intervalId = setInterval(fetchNotifications, 60000)
    return () => clearInterval(intervalId)
  }, [state?.data?.id, page, activeTab])

  const markNotificationAsRead = async (notification) => {
    try {
      await axios.patch(
        `https://staging-backend-v3-express.de.energy/api/notifications/${notification.id}`,
        { status: 'read' }
      )
      setSelectedNotification(notification)
      fetchNotifications()
    } catch (error) {
      console.error('Error marking notification as read:', error)
    }
  }

  const markNotificationAsDone = async (notification, e) => {
    e.stopPropagation()
    try {
      await axios.patch(
        `https://staging-backend-v3-express.de.energy/api/notifications/${notification.id}`,
        { status: 'resolved' }
      )
      fetchNotifications()
    } catch (error) {
      console.error('Error marking notification as done:', error)
    }
  }

  const markCurrentNotificationAsDone = async () => {
    if (!selectedNotification) return

    try {
      await axios.patch(
        `https://staging-backend-v3-express.de.energy/api/notifications/${selectedNotification.id}`,
        { status: 'resolved' }
      )
      setSelectedNotification(null)
      fetchNotifications()
    } catch (error) {
      console.error('Error marking notification as done:', error)
    }
  }

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleBusinessView = () => {
    navigate('/BusinessView', {
      state: { data: state?.data, token: state?.token },
    })
  }
  const handlePlantMapView = () => {
    navigate('/PlantMapView', { state: plantContent })
  }
  const handleOpenEdit = () => {
    navigate('/addnewplant', {
      state: { plantData: plantContent, Edit: true, token: state?.token },
    })
  }
  const handleopenDelete = () => setdelete(true)
  const handleCloseDelete = () => setdelete(false)

  const handleDeleteplant = async (id) => {
    try {
      const resp = await DeletenewplantNew(id, state?.token)
      if (resp?.data) {
        setOpen(true)
        setdelete(false)
        navigate('/solarplantlist')
      }
    } catch (error) {
      console.error('Error deleting plant:', error)
    }
  }

  const handleIssueManagement = () => {
    const plantId = state?.data?.id
    const plantName = state?.data?.plantName
    navigate(
      `/issue-management?plantId=${plantId}&plantName=${encodeURIComponent(
        plantName
      )}`
    )
  }

  const loadPlantIssues = async () => {
    try {
      const issues = await fetchIssues({ plantId: state?.data?.id })
      const openIssues = issues.filter((issue) =>
        ['Open', 'In Progress'].includes(issue.status)
      )
      setPlantIssues(openIssues)
      setIssueCount(openIssues.length)
    } catch (error) {
      console.error('Error loading plant issues:', error)
    }
  }

  useEffect(() => {
    if (state?.data?.id) {
      loadPlantIssues()
      const intervalId = setInterval(loadPlantIssues, 300000)
      return () => clearInterval(intervalId)
    }
  }, [state?.data?.id])

  const handleRemainingDate = () => {
    const currentDate = dayjs()
    const StartDate = state?.data?.commissionDate
    const ENDDate = dayjs(StartDate).add(state?.data?.tenure, 'year')
    const daysLeft = ENDDate.diff(currentDate, 'day')
    const TotaldaysCount = ENDDate.diff(dayjs(StartDate), 'day')
    const CompletedDatePerc = ((TotaldaysCount - daysLeft) / TotaldaysCount) * 100
    setHourGlassValue(CompletedDatePerc)
  }

  const NotificationCard = () => (
    <div
      className="plant_card column_align notification-box"
      onClick={() => setShowNotifications(true)}
    >
      <div className="align_btw">
        <div className="txt1">Notifications</div>
        <div className="notification-badge">
          <MessageIcon className="msg_i" />
          {notificationCount > 0 && (
            <span className="badge">{notificationCount}</span>
          )}
        </div>
      </div>
      <div>
        {notifications.length > 0 ? (
          <div className="line_trim">{notifications[0].message}</div>
        ) : (
          <div className="no-notifications">No notifications</div>
        )}
      </div>
      {notifications.length > 0 && (
        <div className="more_link">
          <a>More</a>
        </div>
      )}
    </div>
  )

  const NotificationDialog = () => (
    <Dialog
      open={showNotifications}
      onClose={() => {
        setShowNotifications(false)
        setSelectedNotification(null)
      }}
      maxWidth="md"
      fullWidth
      className="notification-dialog"
    >
      <div className="notification-dialog-header">
        <span>Notifications</span>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => {
            setActiveTab(newValue)
            setPage(1)
          }}
          className="notification-tabs"
        >
          <Tab value="unread" label="Unread" />
          <Tab value="read" label="Read" />
        </Tabs>
        <IconButton
          onClick={() => {
            setShowNotifications(false)
            setSelectedNotification(null)
          }}
          className="close-button"
        >
          <ClearIcon />
        </IconButton>
      </div>
      <DialogContent>
        {loading ? (
          <div className="loading-spinner">
            <CircularProgress size={20} />
          </div>
        ) : selectedNotification ? (
          <div className="notification-detail">
            <div className="notification-detail-header">
              <IconButton
                onClick={() => setSelectedNotification(null)}
                className="back-button"Button
              >
                <NavigateBefore />
              </IconButton>
              <Button
                variant="contained"
                color="primary"
                className="done-button"
                startIcon={<CheckCircleOutlineIcon />}
                onClick={markCurrentNotificationAsDone}
                disabled={selectedNotification?.isDone}
              >
                {selectedNotification?.isDone ? 'Completed' : 'Mark as Done'}
              </Button>
            </div>
            <div className="notification-detail-content">
              <h3>{selectedNotification.plantName}</h3>
              <p className="timestamp">
                {dayjs(selectedNotification.created_at).format(
                  'DD MMM YYYY | HH:mm'
                )}
              </p>
              <p className="message">{selectedNotification.message}</p>
              {selectedNotification.isDone && (
                <div className="done-status">
                  <CheckCircleOutlineIcon color="success" /> Marked as done on{' '}
                  {dayjs(selectedNotification.doneAt).format(
                    'DD MMM YYYY | HH:mm'
                  )}
                </div>
              )}
            </div>
          </div>
        ) : notifications.length > 0 ? (
          <>
            <div className="notification-list">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${
                    notification.status === 'read' ? 'read' : 'unread'
                  } ${notification.isDone ? 'done' : ''}`}
                  onClick={() => {
                    if (notification.status === 'unread') {
                      markNotificationAsRead(notification)
                    } else {
                      setSelectedNotification(notification)
                    }
                  }}
                >
                  <div className="notification-content">
                    <div className="notification-header">
                      <span className="plant-name">
                        {notification.plantName}
                        {notification.severity === 'high' && (
                          <span className="severity-indicator">●</span>
                        )}
                      </span>
                      <span className="timestamp">
                        {dayjs(notification.created_at).format(
                          'DD MMM YYYY | HH:mm'
                        )}
                      </span>
                    </div>
                    <p className="message">{notification.message}</p>
                    <div className="notification-actions">
                      {notification.isDone ? (
                        <div className="done-indicator">
                          <CheckCircleOutlineIcon
                            color="success"
                            fontSize="small"
                          />{' '}
                          Completed
                        </div>
                      ) : (
                        <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          className="done-button"
                          startIcon={<CheckCircleOutlineIcon />}
                          onClick={(e) =>
                            markNotificationAsDone(notification, e)
                          }
                        >
                          Mark as Done
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {totalPages > 1 && (
              <div className="pagination">
                <IconButton
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  <NavigateBefore />
                </IconButton>
                <span>{`${page} / ${totalPages}`}</span>
                <IconButton
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  <NavigateNext />
                </IconButton>
              </div>
            )}
          </>
        ) : (
          <div className="no-notifications-message">
            No {activeTab} notifications
          </div>
        )}
      </DialogContent>
    </Dialog>
  )

  return (
    <div className={classes.root} id="plantTechnicalView">
      <div className="align_btw mb_10">
        <div>
          <div className="plant_list_h">
            <div className="h_txt1">{plantContent?.plantName}</div>
            <div className="h_txt2">{plantContent?.projectCode}</div>
          </div>
        </div>
        <div>
          <div className="align_end wrap">
            <div className="load_d_p">
              <CircularProgress
                variant="determinate"
                sx={{ scale: '-1 1' }}
                value={hourGlassValue}
                color="success"
                className="progress-bar"
              />
              <div className="loader_pos">
                <img src={LoadingTime} alt="" className="load_width" />
              </div>
            </div>

            <div className="plant_list_h_button mr_8" onClick={handleOpen}>
              <img src={Details} alt="details" className="mr_6" /> Plant Details
            </div>
            <div
              className="plant_list_h_button mr_8"
              onClick={handlePlantMapView}
            >
              <img src={Map} alt="details" className="mr_6" /> Location
            </div>

            <div
              className="plant_list_h_button mr_8"
              onClick={handleIssueManagement}
              style={{ position: 'relative' }}
            >
              <BugReportIcon className="mr_6" style={{ fontSize: '18px' }} />
              Issues
              {issueCount > 0 && (
                <span
                  className="issue-badge"
                  style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    background: '#d32f2f',
                    color: 'white',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  {issueCount}
                </span>
              )}
            </div>

            {(userType === 'admin' || userType === 'sub_admin') && (
              <>
                <RawDataDownload plantData={plantContent} state={state} />
                <div
                  className="business_tech_toggle"
                  onClick={handleBusinessView}
                >
                  <label className="switch">
                    <input type="checkbox" />
                    <span className="slider"></span>
                  </label>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <hr className="brdr_btm" />

      {/* Plant Details Dialog */}
      <Dialog
        className="plant_details_dialog"
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
      >
        <DialogActions>
          <ClearIcon onClick={handleClose} className="pointer" />
        </DialogActions>

        <div className="header">
          <div className="align_btw brdr">
            <div>
              <div className="h_1">Plant Details</div>
            </div>
            <div>
              <div className="align_end">
                <span className="h_2">{plantContent?.plantName}</span>
                {(userType === 'admin' || userType === 'sub_admin') && (
                  <>
                    <IconButton onClick={handleOpenEdit}>
                      <EditIcon className="i_clr" />
                    </IconButton>
                    <IconButton onClick={handleopenDelete}>
                      <DeleteIcon className="i_clr" />
                    </IconButton>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <DialogContent>
          <PlantDetailsContent
            plantData={plantContent}
            dleted={dleted}
            handleCloseDelete={handleCloseDelete}
            handleDeleteplant={handleDeleteplant}
          />
        </DialogContent>
      </Dialog>

      {userType !== 'client' ? (
        <div>
          <div className="plant_main_card_row mb_10">
            {/* Updated cards to use live data */}
            <div className="plant_card column_align">
              <div className="txt1">Daily Energy (MFM)</div>
              <div className="txt2">
                {liveData.dailyEnergyMFM}
              </div>
              <div className="txt3">kWh</div>
            </div>

            <div className="plant_card column_align">
              <div className="txt1">Inverter E. Today (Inverter)</div>
              <div className="txt2">
                {liveData.inverterEToday}
              </div>
              <div className="txt3">kWh</div>
            </div>

            <div className="plant_card column_align">
              <div className="txt1">IR</div>
              <div className="txt2">
                {liveData.gtiValue}
              </div>
              <div className="txt3">
                kWh/m<sup>2</sup>
              </div>
            </div>

            <div className="plant_card column_align">
              <div className="txt1">Specific Yield</div>
              <div className="txt2">{liveData.specificYield}</div>
              <div className="txt3">kWh/kWp</div>
            </div>

            <div className="plant_card column_align">
              <div className="txt1">CO2 Avoided</div>
              <div className="txt2">
                {liveData.co2Avoided}
              </div>
              <div className="txt3">Tonnes</div>
            </div>

            <NotificationCard />
          </div>

          {/* Main Tabs: Graphs and Live */}
          <div className="main-tabs-container">
            <Tabs
              value={liveTabActive}
              onChange={(e, newValue) => setLiveTabActive(newValue)}
              className="main-tabs"
            >
              <Tab value="graphs" label="Graphs" />
              <Tab value="live" label="Live" />
            </Tabs>

            {/* Graphs Tab */}
            {liveTabActive === 'graphs' && (
              <div className="graphs-tab-content">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TechnicalViewGraph
                      state={state?.data}
                      plantContent={plantContent}
                      token={state?.token}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InverterViewGraph
                      state={state?.data}
                      plantContent={plantContent}
                      token={state?.token}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <EnergyAnalysisGraph
                      state={state?.data}
                      plantContent={plantContent}
                      token={state?.token}
                    />
                  </Grid>
                </Grid>
              </div>
            )}

            {/* Live Tab */}
            {liveTabActive === 'live' && (
              <div className="live-tab-content">
                <LiveDataView plantData={plantContent} token={state?.token} />
              </div>
            )}
          </div>

          <NotificationDialog />
        </div>
      ) : (
        <div>
          <Grid item xs={12} md={12}>
            <InverterViewGraph
              state={state?.data}
              plantContent={plantContent}
              token={state?.token}
            />
          </Grid>
        </div>
      )}
    </div>
  )
}

export default PlantTechnicalView
